// extracted by css-extract-rspack-plugin
export default {"backLink":"VDq37yt9w3IFQEK0"};